import * as Actions from 'reducks/pointCard/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const PointCardReducer = (state = initialState.pointCard, action: any) => {
  switch (action.type) {
    case Actions.FETCH_POINT_CARD:
      return {
        ...state,
        pointCard: action.payload,
      }
    case Actions.INIT_POINT_CARD:
      return { ...initialState.pointCard }
    default:
      return state
  }
}
